//CREATE_USER_ROLE
export const CREATE_USER_ROLE_REQUEST = "CREATE_USER_ROLE_REQUEST";
export const CREATE_USER_ROLE_SUCCESS = "CREATE_USER_ROLE_SUCCESS";
export const CREATE_USER_ROLE_FAIL = "CREATE_USER_ROLE_FAIL";

//GET_USER_ROLE
export const GET_USER_ROLE_REQUEST = "GET_USER_ROLE_REQUEST";
export const GET_USER_ROLE_SUCCESS = "GET_USER_ROLE_SUCCESS";
export const GET_USER_ROLE_FAIL = "GET_USER_ROLE_FAIL";

//UPDATE_USER_ROLE
export const UPDATE_USER_ROLE_REQUEST = "UPDATE_USER_ROLE_REQUEST";
export const UPDATE_USER_ROLE_SUCCESS = "UPDATE_USER_ROLE_SUCCESS";
export const UPDATE_USER_ROLE_FAIL = "UPDATE_USER_ROLE_FAIL";

//DELETE_USER_ROLE
export const DELETE_USER_ROLE_REQUEST = "DELETE_USER_ROLE_REQUEST";
export const DELETE_USER_ROLE_SUCCESS = "DELETE_USER_ROLE_SUCCESS";
export const DELETE_USER_ROLE_FAIL = "DELETE_USER_ROLE_FAIL";